export default __webpack_public_path__ + "static/media/slideCampaign-3.a27fd4be.png";